import { DistributionSearchCondition } from '@/common/api/modules/recommendationDistribution'
import {
  ListFollowTableHeaderProps,
  makeRectPropsForTableHeadItem,
  useListScrollFollow
} from '@/common/app/list'
import { RecommendationDistribution } from '@/common/model/recommend/recommendationDistribution'

import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

import ScrollFollowTable from '@/components/container/utils/list/ScrollFollowTable'

import RecommendationDistributionListRow from './RecommendationDistributionListRow'

const HEADERS = [
  '配信ID',
  '配信管理名',
  'ステータス',
  'コンテンツタイプ',
  'A/Bテスト',
  'パターン数',
  '配信開始',
  'A/Bテスト配信終了'
]

const COLUMN_LENGTH = HEADERS.length

interface TheadProps extends ListFollowTableHeaderProps {
  float?: boolean
}

const Thead = ({ float = false, rowRefs, rowRects }: TheadProps) => {
  const rectProps = (index: number) =>
    makeRectPropsForTableHeadItem(rowRefs, rowRects, index, float)

  return (
    <>
      {HEADERS.map((label, index) => (
        <TableHeadItem key={label} float={float} {...rectProps(index)}>
          <Text color={TextColor.SECONDARY} size={12}>
            {label}
          </Text>
        </TableHeadItem>
      ))}
    </>
  )
}

interface Props {
  distributions: RecommendationDistribution[]
  condition: DistributionSearchCondition
  onUpdatePage: (page: number) => void
  total: number
}

const RecommendationDistributionListTable = ({
  distributions,
  condition,
  onUpdatePage,
  total
}: Props) => {
  const listFollowProps = useListScrollFollow(COLUMN_LENGTH)
  const { header } = listFollowProps

  return (
    <ScrollFollowTable
      listFollowProps={listFollowProps}
      tableHead={<Thead {...header} />}
      tableFloatHead={<Thead {...header} float />}
      body={
        <>
          {distributions.map((distribution) => (
            <RecommendationDistributionListRow key={distribution.id} distribution={distribution} />
          ))}
        </>
      }
      condition={condition}
      onUpdatePage={onUpdatePage}
      total={total}
    />
  )
}

export default RecommendationDistributionListTable
